import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'flow-starter-footer',
  templateUrl: './starter-footer.component.html',
  styleUrls: ['./starter-footer.component.scss']
})
export class StarterFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
